import "./personal.less";
import "../../html/tpl/header";
import "../../html/tpl/footer";
import {
  getUrlParams,
  cookieToJson,
  setMediaLen,
  newArr,
  loadDefaultHead,
  commonFunc,
  urlPopCon,
} from "../../js/util";
import { post } from "../../js/http";
import Cookies from "js-cookie";
import storage from "good-storage";

import { bindPop, verCon } from "./bindPhone/bindPhone";

$(document).ready(function () {
  let pUserId;
  if (storage.get("userInfo")) {
    pUserId = storage.get("userInfo").UserID;
  } else {
    window.location.href = "./index.html";
  }

  let leftMenuTemp = require("./pmenu/pmenu.art");
  let leftMenuHtml = leftMenuTemp(storage.get("userInfo"));
  document.getElementById("p-left").innerHTML = leftMenuHtml;

  // 关注列表
  $("#pattentionList").click(function () {
    window.location.href = "./personal.html?dtype=0";
  });
  //粉丝列表
  $("#pfollowList").click(function () {
    window.location.href = "./personal.html?dtype=1";
  });
  //访客列表
  $("#pvistorList").click(function () {
    window.location.href = "./personal.html?dtype=2";
  });

  const personalActiveTab = getUrlParams("type");

  switchTab(personalActiveTab);

  function getNewUserInfo() {
    return new Promise((resolve, reject) => {
      post("/ApiHome/ApiAction?_ControlName=GetUserBaseInfForPC", {
        UserID: storage.get("userInfo").UserID,
      }).then((res) => {
        if (res.ReturnStatus) {
          //更新本地userInfo
          storage.set("userInfo", res.Data);
          resolve(res.ReturnStatus);
        }
      });
    });
  }

  async function switchTab(type) {
    let accountTemp = require("./account/account.art"),
      myprofileTemp = require("./myProfile/myProfile.art"),
      applyentryTemp = require("./applyForEntry/applyForEntry.art"),
      entermanageTemp = require("./entryManage/entryManage.art"),
      settingTemp = require("./setting/setting.art"),
      pointsTemp = require("./points/points.art"),
      callDetailTemp = require("./callDetail/callDetail.art");
    let getUserinfoStatus = await getNewUserInfo();
    if (getUserinfoStatus) {
      switch (type) {
        case "account":
          addTabActive(0);
          post("/ApiHome/ApiAction?_ControlName=GetUserAccountInfoByPC", {
            UserID: storage.get("userInfo").UserID,
          }).then((res) => {
            if (res.ReturnStatus) {
              res.Data["userinfo"] = storage.get("userInfo");
              /**
               * 添加进入提现/银行卡入口
               */
              let active = getUrlParams('active')
              if(active) {
                res.Data.accountTab = active
              }
              var pAccountHtml = accountTemp(res.Data);
              $("#p-right").html(pAccountHtml);
              //模版编译后再将对应js注入
              require("./account/account");
            }
          });
          break;
        case "point":
          addTabActive(1);
          post("/ApiHome/ApiAction?_ControlName=GetScoreDetailByPC", {
            UserID: storage.get("userInfo").UserID,
          }).then((res) => {
            if (res.ReturnStatus) {
              var pointsHtml = pointsTemp(res.Data);
              $("#p-right").html(pointsHtml);
              $(".getpoints-btn").click(function () {
                // 获取积分规则
                getPoints();
              });
            }
          });

          function getPoints() {
            post("/ApiHome/ApiAction?_ControlName=GetGoPageRuleByPC", {
              PackName: "CallMe.PC",
              RuleKey: "ScoreRule",
            }).then((res) => {
              if (res.ReturnStatus) {
                window.open(res.Data.Url, "_blank");
              }
            });
          }
          break;
        case "data":
          if (storage.get("userInfo")) {
            GetUserSpecialtyList(storage.get("userInfo"));
            function GetUserSpecialtyList(newUserInfo) {
              // 获取个人中的特长
              post("/ApiHome/ApiAction?_ControlName=GetUserSpecialtyListByPC", {
                UserID: storage.get("userInfo").UserID,
                type: 3,
              }).then((res) => {
                if (res.ReturnStatus) {
                  newUserInfo["specialityList"] = res.Data.OnlyOneData;
                  if (newUserInfo.VoiceLength) {
                    newUserInfo.transMediaLength = setMediaLen(
                      newUserInfo.VoiceLength
                    );
                  }
                  var myprofileHtml = myprofileTemp(newUserInfo);
                  $("#p-right").html(myprofileHtml);
                  // 添加特长点击事件
                  $(".labelList-con span").click(function () {
                    var index = $(this).index();
                    if ($(this).hasClass("active")) {
                      $(this).removeClass("active");
                    } else {
                      // 最多选三项
                      if ($(".labelList-con span.active").length < 3) {
                        $(this).addClass("active");
                      } else {
                        layer.msg("最多只能勾选三项特长", function () {});
                      }
                    }
                  });
                  require("./myProfile/myProfile.js");
                }
              });
            }
            addTabActive(2);
          }
          break;
        case "record":
          console.log("语聊记录");
          $("#p-right").html(callDetailTemp({}));
          //全部
          getDetail("3001", "#allDetail");
          //拨打
          getDetail("3002", "#dialDetail");
          //接听
          getDetail("3003", "#answerDetail");
          $(".pIndex-nav li").click(function () {
            var index = $(this).index();
            $($(".pIndex-nav li")[index])
              .addClass("active")
              .siblings()
              .removeClass("active");
            $($(".pIndex-content .pIndex-content-item")[index])
              .addClass("active")
              .siblings()
              .removeClass("active");
          });
          addTabActive(3);
          break;
        case "apply":
          console.log("申请入驻");
          let applyUserInfo = storage.get("userInfo");
          // 咨询师申请页面
          post("/ApiHome/ApiAction?_ControlName=GetAngelApplyDataByPC", {
            UserID: storage.get("userInfo").UserID,
            type: 3,
          }).then((res) => {
            if (res.ReturnStatus) {
              applyUserInfo["ApplyData"] = res.Data;
              getSpecialtyList();
              // var applyentryHtml = applyentryTemp(applyUserInfo);
              // $("#p-right").html(applyentryHtml);
              // require("./applyForEntry/applyForEntry.js");
            } else {
              applyUserInfo["ApplyData"] = res;
              getSpecialtyList();
            }
          });
          function getSpecialtyList() {
            // 申请咨询师的特长列表
            post("/ApiHome/ApiAction?_ControlName=GetUserSpecialtyListByPC", {
              UserID: storage.get("userInfo").UserID,
              type: 1,
            }).then((res) => {
              if (res.ReturnStatus) {
                applyUserInfo["ApplyAngelSpecialtyList"] = res.Data.OnlyOneData;
                var applyentryHtml = applyentryTemp(applyUserInfo);
                $("#p-right").html(applyentryHtml);
                require("./applyForEntry/applyForEntry.js");
              }
            });
          }
          addTabActive(4);
          break;
        case "setting":
          let newUserinfo = storage.get("userInfo");
          // 查看接听设置数据
          post("/ApiHome/ApiAction?_ControlName=AnswerSetPageByPC", {
            UserID: storage.get("userInfo").UserID,
            MeterNo: storage.get("userInfo").MeterNo,
          }).then((res) => {
            if (res.ReturnStatus) {
              newUserinfo["AnswerInfo"] = res.Data.OnlyOneData;
              GetUserServiceTime();
            }
          });
          function GetUserServiceTime() {
            // 用户通话时间列表
            post("/ApiHome/ApiAction?_ControlName=GetUserServiceTimeListByPC", {
              UserID: storage.get("userInfo").UserID,
            }).then((res) => {
              let serverTimeList = [
                { WeekDate: "0", SeTime: "" },
                { WeekDate: "1", SeTime: "" },
                { WeekDate: "2", SeTime: "" },
                { WeekDate: "3", SeTime: "" },
                { WeekDate: "4", SeTime: "" },
                { WeekDate: "5", SeTime: "" },
                { WeekDate: "6", SeTime: "" },
              ];
              res.Data.OnlyOneData.map((day) => {
                serverTimeList.map((formatday) => {
                  if (day.WeekDate == formatday.WeekDate) {
                    formatday.SeTime = day.SeTime;
                  }
                });
              });
              if (res.ReturnStatus) {
                serverTimeList.forEach((item) => {
                  item.SeTime = item.SeTime.split(",");
                  if (item.SeTime.length && item.SeTime[0] != "") {
                    // 排除 SeTime == [""]
                    item.SeTimeStr = new Array();
                    item.SeTime.forEach((itemm) => {
                      if (itemm * 1 < 9) {
                        item.SeTimeStr.push(
                          "0" +
                            itemm * 1 +
                            ":00-" +
                            "0" +
                            (itemm * 1 + 1) +
                            ":00"
                        );
                      } else if (itemm * 1 == 9) {
                        item.SeTimeStr.push("09:00-10:00");
                      } else if (itemm * 1 > 9) {
                        item.SeTimeStr.push(
                          itemm * 1 + ":00-" + (itemm * 1 + 1) + ":00"
                        );
                      }
                    });
                    item.newArrTimeStr = newArr(item.SeTimeStr);
                  }
                });
              }
              newUserinfo["ServerTime"] = serverTimeList;
              var settingHtml = settingTemp(newUserinfo);
              $("#p-right").html(settingHtml);
              require("./setting/setting.js");
            });
          }

          addTabActive(5);
          break;
        case "manage":
          console.log("入驻管理");
          let manageUserinfo = storage.get("userInfo");
          post("/ApiHome/ApiAction?_ControlName=LevelManageByPC", {
            UserID: storage.get("userInfo").UserID,
            type: 3,
          }).then((res) => {
            if (res.ReturnStatus) {
              manageUserinfo["LevelManageInfo"] = res.Data;
              getUserCallNumAndIncome();
            }
          });
          function getUserCallNumAndIncome() {
            post(
              "/ApiHome/ApiAction?_ControlName=GetUserCallNumAndIncomeByPC",
              {
                UserID: storage.get("userInfo").UserID,
                type: 3,
              }
            ).then((res) => {
              if (res.ReturnStatus) {
                manageUserinfo["UserCallNumAndIncome"] = res.Data.OnlyOneData;
                var entermanageHtml = entermanageTemp(manageUserinfo);
                $("#p-right").html(entermanageHtml);
                let minFee = Number(
                    manageUserinfo["LevelManageInfo"]["ExpensesConfig"][
                      "MinFeeAmount"
                    ]
                  ),
                  maxFee = Number(
                    manageUserinfo["LevelManageInfo"]["ExpensesConfig"][
                      "MaxFeeAmount"
                    ]
                  ),
                  feeLevelStr = "";
                console.log(minFee, maxFee);
                for (var i = 0; i <= (maxFee - minFee) * 10; i++) {
                  console.log(1);
                  feeLevelStr +=
                    "<option value='" +
                    (minFee + 0.1 * i).toFixed(1) +
                    "'>" +
                    (minFee + 0.1 * i).toFixed(1) +
                    "声币/分钟</option>";
                }
                $("#feeInput").html(feeLevelStr);
                layui.use(["form"], function () {
                  var form = layui.form;
                  form.render("select");
                });

                console.log(feeLevelStr);
                require("./entryManage/entryManage.js");
              }
            });
          }
          addTabActive(4);
          break;
        default:
          post("/ApiHome/ApiAction?_ControlName=GetMyUserInfoByPC", {
            UserID: storage.get("userInfo").UserID,
          }).then((res) => {
            if (res.ReturnStatus) {
              let pIndexTemp = require("./pIndex/pIndex.art");
              let pIndexHtml = pIndexTemp(res.Data);
              $("#p-right").html(pIndexHtml);

              getList(
                "/ApiHome/ApiAction?_ControlName=GetAttentionListByPC",
                "#attentionList"
              );
              getList(
                "/ApiHome/ApiAction?_ControlName=GetUserFansByPC",
                "#followList"
              );
              if (storage.get("userInfo").IsVIP) {
                //是VIP
                getList(
                  "/ApiHome/ApiAction?_ControlName=GetUserVisitRecordByPC",
                  "#visitList"
                );
              }
              getList(
                "/ApiHome/ApiAction?_ControlName=GetUserBlackRecordByPC",
                "#blackList"
              );
              // 根据参数默认跳转 关注列表/粉丝列表/访客列表/黑名单
              const dtype = getUrlParams("dtype");
              function jumpList(index) {
                $($(".pIndex-nav li")[index])
                  .addClass("active")
                  .siblings()
                  .removeClass("active");
                $($(".pIndex-content .pIndex-content-item")[index])
                  .addClass("active")
                  .siblings()
                  .removeClass("active");
              }
              switch (dtype) {
                case "0":
                  jumpList(0);
                  break;
                case "1":
                  jumpList(1);
                  break;
                case "2":
                  jumpList(2);
                  break;
                default:
                  jumpList(0);
                  break;
              }

              $(".pIndex-nav li").click(function () {
                var index = $(this).index();
                index === 2
                  ? $(".pIndex-con #visitor-label").show()
                  : $(".pIndex-con #visitor-label").hide();
                $($(".pIndex-nav li")[index])
                  .addClass("active")
                  .siblings()
                  .removeClass("active");
                $($(".pIndex-content .pIndex-content-item")[index])
                  .addClass("active")
                  .siblings()
                  .removeClass("active");
              });
            }
          });

          break;
      }
    }
  }

  function addTabActive(key) {
    $("#p-left .p-nav-box a").each((index, item) => {
      if (key == index) {
        $(item).addClass("active");
      } else {
        $(item).removeClass("active");
      }
    });
  }

  function getList(url, dom) {
    layui.use("flow", function () {
      var $ = layui.jquery; //不用额外加载jQuery，flow模块本身是有依赖jQuery的，直接用即可。
      var flow = layui.flow;

      flow.load({
        elem: dom, //指定列表容器
        done: function (page, next) {
          //到达临界点（默认滚动触发），触发下一页
          post(url, {
            UserID: pUserId,
            PageIndex: page,
            PageSize: 10,
          }).then((res) => {
            if (res.ReturnStatus && res.Data.OnlyOneData) {
              let pUserListTemp;
              switch (dom) {
                case "#attentionList":
                  res.Data.userListType = 1;
                  pUserListTemp = require("./pIndex/userList.art");
                  var pUserListHtml = pUserListTemp(res.Data);
                  next(pUserListHtml, page < res.Data.TotalPage);
                  // 添加通话功能
                  optCall();
                  // 加载默认头像
                  loadDefaultHead();
                  break;
                case "#followList":
                  res.Data.userListType = 2;
                  pUserListTemp = require("./pIndex/userList.art");
                  var pUserListHtml = pUserListTemp(res.Data);
                  next(pUserListHtml, page < res.Data.TotalPage);
                  optAttentionList();
                  // 加载默认头像
                  loadDefaultHead();
                  break;
                case "#visitList":
                  res.Data.userListType = 3;
                  pUserListTemp = require("./pIndex/userList.art");
                  var pUserListHtml = pUserListTemp(res.Data);
                  next(pUserListHtml, page < res.Data.TotalPage);
                  optAttentionList();
                  // 加载默认头像
                  loadDefaultHead();
                  break;
                case "#blackList":
                  res.Data.userListType = 4;
                  pUserListTemp = require("./pIndex/userList.art");
                  var pUserListHtml = pUserListTemp(res.Data);
                  next(pUserListHtml, page < res.Data.TotalPage);
                  optBlackList();
                  // 加载默认头像
                  loadDefaultHead();
                  break;
              }
            } else {
              let pUserListTemp;
              switch (dom) {
                case "#attentionList":
                  res.Data.userListType = 1;
                  pUserListTemp = require("./pIndex/userList.art");
                  var pUserListHtml = pUserListTemp(res.Data);
                  next(pUserListHtml, page < 0);
                  break;
                case "#followList":
                  res.Data.userListType = 2;
                  pUserListTemp = require("./pIndex/userList.art");
                  var pUserListHtml = pUserListTemp(res.Data);
                  next(pUserListHtml, page < 0);
                  optAttentionList();
                  // 加载默认头像
                  loadDefaultHead();
                  break;
                case "#visitList":
                  res.Data.userListType = 3;
                  pUserListTemp = require("./pIndex/userList.art");
                  var pUserListHtml = pUserListTemp(res.Data);
                  next(pUserListHtml, page < 0);
                  optAttentionList();
                  // 加载默认头像
                  loadDefaultHead();
                  break;
                case "#blackList":
                  res.Data.userListType = 4;
                  pUserListTemp = require("./pIndex/userList.art");
                  var pUserListHtml = pUserListTemp(res.Data);
                  next(pUserListHtml, page < 0);
                  break;
              }
            }
          });
        },
        end: "没有更多了",
      });
    });
  }

  function getDetail(type, dom) {
    layui.use("flow", function () {
      var $ = layui.jquery; //不用额外加载jQuery，flow模块本身是有依赖jQuery的，直接用即可。
      var flow = layui.flow;
      flow.load({
        elem: dom, //指定列表容器
        done: function (page, next) {
          //到达临界点（默认滚动触发），触发下一页
          post("/ApiHome/ApiAction?_ControlName=GetUserCallListByPC", {
            UserID: pUserId,
            Position: type,
            PageIndex: page,
            PageSize: 10,
          }).then((res) => {
            if (res.ReturnStatus) {
              let callDetailListTemp = require("./callDetail/callDetailList.art");
              var callDetailListHtml = callDetailListTemp(res.Data);
              next(
                callDetailListHtml,
                page < Math.ceil(res.Data.TotalRowsCount / 10)
              );
              // require("./callDetail/callDetailList.js");
              if (dom == "#allDetail") {
                $("#allDetail .detailCallBtn").click(function () {
                  let userID = $(this).attr("data-id");
                  callFunc(userID);
                });
                $("#allDetail .detailMagicBtn").click(function () {
                  let userID = $(this).attr("data-id");
                  migicCallFunc(userID);
                });
              } else if (dom == "#dialDetail") {
                $("#dialDetail .detailCallBtn").click(function () {
                  let userID = $(this).attr("data-id");
                  callFunc(userID);
                });
                $("#dialDetail .detailMagicBtn").click(function () {
                  let userID = $(this).attr("data-id");
                  migicCallFunc(userID);
                });
              } else {
                $("#answerDetail .detailCallBtn").click(function () {
                  let userID = $(this).attr("data-id");
                  callFunc(userID);
                });
                $("#answerDetail .detailMagicBtn").click(function () {
                  let userID = $(this).attr("data-id");
                  migicCallFunc(userID);
                });
              }
            }
          });
        },
      });
    });
  }
  // *****************分割线*******************以下是拨打电话的方法*******************分割线*******************
  let toCallUserInfo = {}; //被呼叫者的信息
  function callFunc(userID) {
    let callTpl = require("../home/call/call.art"),
      callLayer = null;
    post("/ApiHome/ApiAction?_ControlName=ShowCallStatusByPC", {
      ToUserID: userID,
    }).then((res) => {
      if (res.ReturnStatus) {
        let callHtml = callTpl(res.Data);
        $("#call-con").html(callHtml);
        callLayer = layer.open({
          type: 1,
          skin: "layer-custom",
          btnAlign: "c",
          area: ["490px", "470px"],
          title: "",
          closeBtn: 2,
          id: "callCon",
          content: $("#call-con"),
          end: function () {
            $("#call-con").hide();
          },
        });
        toCallUserInfo = res.Data;
        $("#dail-btn").off("click");
        $(".dail-btn").click(function () {
          // 开始拨打
          beginCall(res.Data.FreeCount);
        });
      } else {
        layer.msg(res.MessageCN, { icon: 2 });
      }
    });

    // 计时器
    let refreshInter = null;
    function beginCall(FreeCount) {
      var data = {
        ToUserID: userID,
        UseFree: FreeCount > 0 ? 1 : 0,
      };

      post("/ApiHome/ApiAction?_ControlName=BeginCallByPC", data).then(
        (res) => {
          if (res.ReturnStatus) {
            layer.close(callLayer);
            refreshCallOrder(res.Data.OnlyOneData.OrderID);
            refreshInter = setInterval(function () {
              refreshCallOrder(res.Data.OnlyOneData.OrderID);
            }, 5000);
          } else {
            if (res.MessageID == -10243) {
              //余额不足3分钟
              let contentStr =
                "<div style='color:#666;font-size: 14px;text-align:center'>您的余额不足，请先充值。</div><div class='btn-wrap' style='padding-top: 40px;text-align: center'><a class='w130btn cancleColor mr5 cancelbtn' style='line-height: 38px;'>取消</a><a href='./recharge.html' class='w130btn themeColor ml5 confirmbtn'>去充值</a></div>";
              confirmPopCon(contentStr);
            } else {
              layer.msg(res.MessageCN, { icon: 2 });
            }
          }
        }
      );
    }

    function refreshCallOrder(orderID) {
      let callingTpl = require("../home/call/calling.art");
      // 5s执行一次
      post("/ApiHome/ApiAction?_ControlName=RefreshCallOrderByPC", {
        OrderID: orderID,
      }).then((res) => {
        if (res.ReturnStatus) {
          let callingHtml, callingLayer;
          switch (res.Data.OnlyOneData.Result) {
            case 0:
              // 任一用户挂断
              layer.msg("已挂断");
              clearInterval(refreshInter);
              break;
            case 1:
              // 呼叫中
              callingHtml = callingTpl(res.Data.OnlyOneData);
              $("#calling-con").html(callingHtml);
              break;
            case 2:
              // 已经拨通双方
              callingHtml = callingTpl(res.Data.OnlyOneData);
              $("#calling-con").html(callingHtml);
              break;
            case 3:
              // 成功通话后挂断
              callingHtml = callingTpl(res.Data.OnlyOneData);
              $("#calling-con").html(callingHtml);
              clearInterval(refreshInter);
              break;
            case 4:
              // 对方可能暂时不方便接听
              callingHtml = callingTpl(res.Data.OnlyOneData);
              $("#calling-con").html(callingHtml);
              clearInterval(refreshInter);
              break;
            case 5:
              // 呼叫失败，话单结束，未能接通主叫 平台来电未能接通您的电话
              callingHtml = callingTpl(res.Data.OnlyOneData);
              $("#calling-con").html(callingHtml);
              clearInterval(refreshInter);
              break;
            case 6:
              // 正在接通中
              callingHtml = callingTpl(res.Data.OnlyOneData);
              $("#calling-con").html(callingHtml);
              break;
          }
          callingLayer = layer.open({
            type: 1,
            skin: "layer-custom",
            btnAlign: "c",
            area: ["490px", "470px"],
            title: "",
            closeBtn: 2,
            id: "callingCon",
            content: $("#calling-con"),
            end: function () {
              $("#calling-con").hide();
              clearInterval(refreshInter);
            },
          });
          $("#dail-btn").off("click");
          $("#dail-btn").click(function () {
            //重新拨打
            beginCall(res.Data.FreeCount);
          });
          $(".opt-follow-btn").click(function () {
            optFollow($(this), userID);
          });
        } else {
          layer.msg(res.MessageCN, { icon: 2 });
          clearInterval(refreshInter);
        }
      });
    }

    function optFollow(el, userID) {
      let optType = null;
      // optType==1 执行关注 ;optType==2 执行取消关注
      el.text() == "关注" ? (optType = 1) : (optType = 2);
      post("/ApiHome/ApiAction?_ControlName=AddAttentionByPC", {
        ToUserID: userID,
      }).then((res) => {
        if (res.ReturnStatus) {
          if (optType == 1) {
            el.text("已关注");
            el.removeClass("follow-btn").addClass("has-follow-btn");
          } else {
            el.text("关注");
            el.removeClass("has-follow-btn").addClass("follow-btn");
          }
        } else {
          layer.msg(res.MessageCN, { icon: 2 });
        }
      });
    }
  }

  function migicCallFunc(userID) {
    let magicLayer;
    let magicWakeTpl = require("../home/homeHeader/magicWake.art");
    if (!storage.get("userInfo")) {
      window.openLoginCon();
      return;
    }
    // 获取魔术唤醒列表
    post("/ApiHome/ApiAction?_ControlName=GetAwakenListByPC", {
      ToUserID: userID,
    }).then((res) => {
      if (res.ReturnStatus) {
        let wakeData = res.Data.OnlyOneData;
        wakeData["IsMobileOk"] = storage.get("userInfo").IsMobileOk;
        $("#magicWake-con").html(magicWakeTpl(wakeData));
        magicLayer = layer.open({
          type: 1,
          skin: "layer-custom",
          area: ["600px", ""],
          title: "",
          id: "magicWakeCon",
          closeBtn: 0,
          content: $("#magicWake-con"),
          end: function () {
            $("#magicWake-con").hide();
          },
        });
        $("#magicWake-con .icon-close").click(function () {
          layer.closeAll();
        });
        // 发送魔术唤醒请求
        requestWake(userID);
      } else {
        layer.msg(res.MessageCN, { icon: 2 });
      }
    });
    function requestWake(userID) {
      $(".magicWake-content .magicWake-content-item").click(function () {
        $(this).addClass("active").siblings().removeClass("active");
      });
      // 发送魔术唤醒
      $("#toWaking").click(function () {
        const wakeID = $(
          ".magicWake-content .magicWake-content-item.active"
        ).attr("data-id");
        post("/ApiHome/ApiAction?_ControlName=SendAwakenByPC", {
          ToUserID: userID,
          CID: wakeID,
          UserID: pUserId,
        }).then((res) => {
          let contentStr;
          switch (res.MessageID) {
            case -10230:
              // 需要绑定手机
              contentStr =
                "<div style='color:#666;font-size: 14px;text-align:center'>" +
                res.MessageCN +
                "</div><div class='btn-wrap' style='padding-top: 40px;text-align: center'><a class='w130btn cancleColor mr5 cancelbtn' style='line-height: 38px;'>取消</a><a class='w130btn themeColor ml5' id='toBindbtn'>去绑定</a></div>";
              layer.closeAll();
              confirmPopCon(contentStr);
              break;
            case -10331:
            case -10332:
              // 需要充值
              contentStr =
                "<div style='color:#666;font-size: 14px;text-align:center'>" +
                res.MessageCN +
                "</div><div class='btn-wrap' style='padding-top: 40px;text-align: center'><a class='w130btn cancleColor mr5 cancelbtn' style='line-height: 38px;'>取消</a><a href='./recharge.html' class='w130btn themeColor ml5 confirmbtn'>去充值</a></div>";
              layer.closeAll();
              confirmPopCon(contentStr);
              break;
            case -10466:
            default:
              layer.closeAll();
              layer.msg(res.MessageCN);
              break;
          }
        });
      });
      $("#toBind").click(function () {
        layer.closeAll();
        (function inintVerCon() {
          let bindPhoneTemp = require("./bindPhone/bindPhone.art");
          $("#bindPhone-con").html(bindPhoneTemp(storage.get("userInfo")));
          bindPop();
          verCon();
        })();
      });
    }
  }
  // ***************分割线********************************************分割线***************
  function optCall() {
    $(".detailCallBtn").off("click");
    $(".detailCallBtn").click(function () {
      const userID = $(this).attr("data-id");
      callFunc(userID);
    });
    $(".detailMagicBtn").off("click");
    $(".detailMagicBtn").click(function () {
      let userID = $(this).attr("data-id");
      migicCallFunc(userID);
    });
  }

  function optAttentionList() {
    // 添加关注/取消关注
    $(".attentionListOpt").off("click");
    $(".attentionListOpt").click(function () {
      post("/ApiHome/ApiAction?_ControlName=AddAttentionByPC", {
        ToUserID: $(this).attr("data-id"),
      }).then((res) => {
        if (res.ReturnStatus) {
          if ($(this).text() === "关注") {
            $(this).removeClass("light-btn").addClass("dark-btn");
            $(this).text("已关注");
          } else {
            $(this).removeClass("dark-btn").addClass("light-btn");
            $(this).text("关注");
          }
          layer.msg(res.MessageCN, { icon: 1 });
        } else {
          layer.msg(res.MessageCN, { icon: 2 });
        }
      });
    });
  }

  function optBlackList() {
    // 加入黑名单/移出黑名单
    $(".blackListOpt").off("click");
    $(".blackListOpt").click(function () {
      post("/ApiHome/ApiAction?_ControlName=BlackUserOperationByPC", {
        ToUserID: $(this).attr("data-id"),
      }).then((res) => {
        if (res.ReturnStatus) {
          if ($(this).text() === "移出黑名单") {
            $(this).removeClass("light-btn").addClass("dark-btn");
            $(this).text("加入黑名单");
          } else {
            $(this).removeClass("dark-btn").addClass("light-btn");
            $(this).text("移出黑名单");
          }
          layer.msg(res.MessageCN, { icon: 1 });
          setTimeout(() => {
            location.reload();
          }, 1500);
        } else {
          layer.msg(res.MessageCN, { icon: 2 });
        }
      });
    });
  }

  function confirmPopCon(str) {
    $(".confirmPop-content-con").html(str);
    let confirmLayer = layer.open({
      type: 1,
      skin: "layer-custom",
      area: ["400px", ""],
      title: "",
      id: "confirmPopCon",
      closeBtn: 0,
      content: $("#confirmPop"),
      end: function () {
        $("#confirmPop").hide();
      },
    });
    $("#confirmPop .icon-close").click(function () {
      layer.close(confirmLayer);
    });
    $("#confirmPop .cancelbtn").click(function () {
      layer.close(confirmLayer);
    });
    $("#toBindbtn").click(function () {
      layer.closeAll();
      (function inintVerCon() {
        let bindPhoneTemp = require("./bindPhone/bindPhone.art");
        $("#bindPhone-con").html(bindPhoneTemp(storage.get("userInfo")));
        bindPop();
        verCon();
      })();
    });
  }
});
